import React from 'react';
import { Box, Flex, Switch, Text } from '@chakra-ui/react';
import PropType from 'prop-types';

function SettingInfo({ watch, title, description, name, onChange, isDisabled = false }) {
  return (
    <>
      <Text
        fontWeight="medium"
        mb={3}
      >
        {title}
      </Text>
      <Flex justify="space-between">
        <Box w="85%">
          <Text
            color="greyScale.800"
            textStyle="bodyMd"
          >
            {description}
          </Text>
        </Box>
        <Box alignItems="flex-end" pr="10px" textAlign="right" w="10%">
          <Switch
            dusk={name}
            isChecked={watch(name)}
            isDisabled={isDisabled}
            name={name}
            size="md"
            width="40px"
            onChange={e => onChange(e.target.checked)}
          />
        </Box>
      </Flex>
    </>
  );
}

SettingInfo.propTypes = {
  watch: PropType.func.isRequired,
  title: PropType.string,
  description: PropType.string,
  onChange: PropType.func,
  name: PropType.string.isRequired,
  isDisabled: PropType.bool
};

export default SettingInfo;
